import { FC } from 'react';
import styled from '@emotion/styled';
import type { DTOShopTab } from 'src/apis/dto/DTOShopTab';
const TabsWrapper = styled.div`
  display: flex;
  gap: 8px;
  padding: 16px;
  padding-inline-start: 16px;
`;
const TabChip = styled.button<{
  $isActive: boolean;
}>`
  all: unset;
  box-sizing: border-box;
  cursor: pointer;
  padding-inline: 16px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50px;
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
  white-space: nowrap;

  ${({
  $isActive,
  theme
}) => $isActive ? `
    border: 1px solid ${theme.color.accentH1};
    color: ${theme.color.accentH1};
  ` : `
    border: 1px solid ${theme.color.surface6};
    color: ${theme.color.content9};
  `}
`;
export type ShopTab = string;
interface Props {
  tabs: DTOShopTab[];
  activeTab: string;
  onTabChange: (anchor: string) => void;
}
const ShopTabs: FC<Props> = ({
  tabs,
  activeTab,
  onTabChange
}) => {
  return <TabsWrapper data-sentry-element="TabsWrapper" data-sentry-component="ShopTabs" data-sentry-source-file="ShopTabs.tsx">
      {tabs.map(tab => <TabChip key={tab.anchor} $isActive={activeTab === tab.anchor} onClick={() => onTabChange(tab.anchor)}>
          {activeTab === tab.anchor ? tab.activeName : tab.name}
        </TabChip>)}
    </TabsWrapper>;
};
export default ShopTabs;